import { Box, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { FlexBox } from '../../../../components/tableItems';
import { MainButton } from '../../../../components/buttons';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 380,
  bgcolor: 'background.paper',
  borderRadius: '7px',
  boxShadow: 24,
  px: 3,
  pt: 2,
  pb: 3,
};

interface AliasSendTestProps {
  confirmationModal: boolean;
  closeConfirmationModal: () => void;
  confirmAction: () => void;
  isLoading: boolean;
}

const AliasSendTest: React.FC<AliasSendTestProps> = ({
  closeConfirmationModal,
  confirmationModal,
  confirmAction,
  isLoading,
}) => {
  return (
    <Modal open={confirmationModal}>
      <Box sx={style}>
        <>
          <Box justifyContent="end" display="flex">
            <IconButton onClick={closeConfirmationModal} sx={{ fontSize: 17 }}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Box>
          <Typography
            fontWeight={700}
            fontSize={17}
            textAlign="center"
            textTransform="capitalize"
          >
            Send Test to this Alias
          </Typography>
          <Typography marginTop={2} fontSize={14} textAlign="center">
            Are you sure you want to send a test to this alias?
          </Typography>
          <Box marginTop={3.5}>
            <FlexBox marginTop={3} justifyContent="center">
              <MainButton
                disabled={isLoading}
                onClick={() => closeConfirmationModal()}
                variant="contained"
                sx={{
                  backgroundColor: '#F0F0F0',
                  color: 'black',
                  marginRight: 1,
                  '&:hover': {
                    backgroundColor: '#F2F2F2',
                  },
                }}
              >
                Cancel
              </MainButton>
              <MainButton
                variant="contained"
                onClick={confirmAction}
                disabled={false}
                loading={isLoading}
                sx={{ marginLeft: 1 }}
              >
                Confirm
              </MainButton>
            </FlexBox>
          </Box>
        </>
      </Box>
    </Modal>
  );
};

export default AliasSendTest;
